import { camelize } from 'util/strings'

export default function requestsReducer(
  state = {},
  { type, meta: { requestKey } = {}, payload }
) {
  const actionName = camelize(type.substring(0, type.lastIndexOf('_')))
  const actionType = type.split('_').pop()
  const id = requestKey || actionName
  let updated = {}
  switch (actionType) {
    case 'STARTED':
    case 'REQUEST':
      updated = {
        untried: false,
        loading: true,
        loaded: false,
        error: false,
      }
      break
    case 'SUCCESS':
      updated = {
        untried: false,
        loading: false,
        loaded: true,
        error: false,
      }
      break
    case 'FAILED':
      updated = {
        untried: false,
        loading: false,
        loaded: false,
        error: payload,
      }
      break
    default:
      return state
  }
  return {
    ...state,
    [id]: updated,
  }
}
